if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}
function msieversion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    const image_fit = document.getElementsByClassName("image-fit__wrapper");
    for (let i = 0; i < image_fit.length; i++) {
      const this_image = image_fit[i].getElementsByTagName("img")[0];
      const image_data = this_image.dataset.srcset;
      const image_src = this_image.getAttribute("src");
      image_fit[i].classList.add("ie-bg");
      if (image_data) {
        image_fit[i].style.backgroundImage = 'url("' + image_data + '")';
      } else {
        image_fit[i].style.backgroundImage = 'url("' + image_src + '")';
      }
    }
  } else {
    console.log("other browser");
  }

  return false;
}
msieversion();

// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
  $(document).ready(function () {
    // $('.sym-slides').slick();

    //Call function with browser is resized.
    // $(window).resize(function (event) {
    // 	resizeWindow();
    // });
    // resizeWindow();

    //Acts when scroll down page.
    // $(window).scroll(function (event) {
    // 	scrollDown();
    // });

    if( document.querySelector(`.js-containerWebcamPhone`) ){
      let arrow_WebcamPhone = document.querySelector(`.dropdown_phoneAndWebcam-arrow`),
          options_WebcamPhone = document.querySelector(`.dropdown_phoneAndWebcam-options`);

      arrow_WebcamPhone.addEventListener( 'click', () => {
        options_WebcamPhone.classList.toggle('hidden');
      } );
    }

    document
      .querySelector("#js-booking")
      .addEventListener("click", function () {
        document.querySelector(".booking").classList.add("open");
      });
    document
      .querySelector("#js-close-booking")
      .addEventListener("click", function () {
        document.querySelector(".booking").classList.remove("open");
      });

    // Main Nav Dropdown
    $("#primary-nav li").hover(
      function () {
        $(this).addClass("hover");
        $("ul.submenu", this).fadeIn(200);
      },
      function () {
        $(this).removeClass("hover");
        $("ul.submenu", this).fadeOut(200);
      }
    );

    //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
    let DATE_STYLE = [true];
    function calendarRange(date) {
      let d1 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckIn").val());
      let d2 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckOut").val());
      if (
        (d1 && date.getTime() == d1.getTime()) ||
        (d2 && date.getTime() == d2.getTime())
      ) {
        DATE_STYLE[1] = "highlight-top";
      } else if (date > d1 && date < d2) {
        DATE_STYLE[1] = "highlight";
      } else {
        DATE_STYLE[1] = "";
      }
      return DATE_STYLE;
    }

    //Check in and check out datepicker for booking engine
    const DATE_FORMAT =
      $("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")
        ? $("#CheckIn").data("format")
        : "yy-mm-dd";
    $("#CheckIn").datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      changeMonth: true,
      dateFormat: DATE_FORMAT,
      numberOfMonths: 1,
      minDate: 0,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        let getDate = $(this).datepicker("getDate");
        let newDate = new Date(getDate.getTime());
        newDate.setDate(newDate.getDate() + 3);
        $("#CheckOut").datepicker("setDate", newDate);
        $("#CheckOut").datepicker("option", "minDate", selectedDate);
      },
    });
    $("#CheckOut").datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      dateFormat: DATE_FORMAT,
      changeMonth: true,
      numberOfMonths: 1,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
      },
    });

    // Map: Return to previous page button. Change body id to match map template's name.
    //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
  });

  window.onload = function () {
    /*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

    // scrollDownAction(20, 'scroll');

    scrollW();
    window.addEventListener("scroll", function () {
      scrollW();
    });
  };
})();

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("down")) {
        document.getElementById("header").classList.add("down");
        document.getElementById("header").classList.remove("up");
      }
    } else {
      // upscroll code
      if (!document.getElementById("header").classList.contains("up")) {
        document.getElementById("header").classList.add("up");
        document.getElementById("header").classList.remove("down");
      }
    }
  } else {
    if (
      document.getElementById("header").classList.contains("up") ||
      document.getElementById("header").classList.contains("down")
    ) {
      document.getElementById("header").classList.remove("up");
      document.getElementById("header").classList.remove("down");
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  const window_height = window.innerHeight;
  let animatedEl = document.getElementsByClassName("animate-fade-2");
  for (let i = 0; i < animatedEl.length; i++) {
    var viewportOffset = animatedEl[i].getBoundingClientRect();
    let topPos = viewportOffset.top;
    if (topPos <= window_height * 0.8) {
      animatedEl[i].classList.add("fade-in");
    }
  }
}

function getTest(menu_id) {
  $.get(
    `${site_url}ajax/functions.php`,
    { operation: "getTest", menu_id: menu_id },
    function (data) {
      $.fancybox(data);
    }
  );
}

function getMenu(menu_id) {
  $.get(
    `${site_url}ajax/functions.php`,
    { operation: "getMenu", menu_id: menu_id },
    function (data) {
      $.fancybox(data);
      $(".menu-tabs li").click(function () {
        $(".menu-tabs li").removeClass("active");
        $(this).addClass("active");
        var disMenu = $(this).index();
        $(".menu-view").removeClass("active");
        $(".menu-view:eq(" + disMenu + ")").addClass("active");
      });
    }
  );
}

// RESTAURANT MENUS FILTER
document.querySelectorAll(".restMenus_filter li").forEach((btn, i) => {
  btn.addEventListener("click", (_) => {
    document
      .querySelectorAll(".restMenus_filter li")
      .forEach((b) => b.classList.remove("active"));
    btn.classList.add("active");

    document.querySelectorAll(".dining-menus_item").forEach((room) => {
      room.classList.remove("active");
      if (btn.dataset.tag === "all" || btn.dataset.tag === room.dataset.tag) {
        room.classList.add("active");
      }
    });
  });

  if (i === 0) btn.click();
});
